export const ADMIN_PATH = '/'

export const buildK8ReportSitePath = (unitSection, siteId) =>
  `/reports/k8/${unitSection}?site=${siteId}`

export const SCHOOL_SUMMARY_BREADCRUMB = 'School Overview'
export const LESSON_COMPLETION_REPORTS_TITLE = 'Lesson Completion Reports'

/** Tab: Specialized Units in lesson-completion report header (ReportsPageHeader flag.on). */
export const FEATURE_SPECIALIZED_UNITS_TAB =
  'feature_LEARN-27700_specialized-lesson-completion-updates'
